import $ from 'cash-dom';
import animate from '../components/animate';

const KEY_CONSENTED = 'acceptCookiesConsented';
const AcceptCookies = {consented: localStorage.getItem(KEY_CONSENTED)};
let scrollHandler = null;

$(function () {
  const CONSIDER_CONSENTED_HEIGHT_COEFFICIENT_DESKTOP = 0.80
  const CONSIDER_CONSENTED_HEIGHT_COEFFICIENT_MOBILE = 0.25
  const $acceptCookies = $('#accept-cookies');

  if (!$acceptCookies.length) {
    closeAcceptCookies();
    return;
  }

  if (!AcceptCookies.consented) {
    animate.fadeIn($acceptCookies, 600);
    handleAcceptCookiesScroll();
  }

  function handleAcceptCookiesScroll() {
    scrollHandler = function () {
      let $window = $(window);

      const scrollTop = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop;
      const windowHeight = $window.height();
      const desktopHeightToConsiderConsented = windowHeight * CONSIDER_CONSENTED_HEIGHT_COEFFICIENT_DESKTOP
      const mobileHeightToConsiderConsented = windowHeight * CONSIDER_CONSENTED_HEIGHT_COEFFICIENT_MOBILE

      const desktopScrolledEnough = $window.width() >= 768 && (scrollTop - desktopHeightToConsiderConsented) > 0;
      const mobileScrolledEnough = $window.width() < 768 && (scrollTop - mobileHeightToConsiderConsented) > 0;

      if (desktopScrolledEnough || mobileScrolledEnough) {
        closeAcceptCookies();
      }
    };

    window.addEventListener('scroll', scrollHandler);

    $('.close-cookies').on('click', function (e) {
      e.preventDefault();
      closeAcceptCookies();
    });
  }

  function closeAcceptCookies() {
    localStorage.setItem(KEY_CONSENTED, '1');
    AcceptCookies.consented = true;

    animate.fadeOut($acceptCookies, 1500);

    if (scrollHandler) {
      window.removeEventListener('scroll', scrollHandler);
    }

    $(document).trigger('cookies-consented');
  }
});

export { AcceptCookies };
export default { AcceptCookies };
